import api from "../../api/axios";

export const generatePdf = async ({type, calc, data})=>{
    try {
        const res = await api.post('/pdf/generate', {
            type,
            calc,
            data ,
            mrsid: data?.mrsid ,
            optionType: data?.optionType,
            // pdf.controller.js reads this at the top level of the request
            // body (it drives template selection, separate from optionType
            // which is just a tracking label) — promote it the same way
            // mrsid/optionType already are, or it stays buried in `data`
            // and never reaches the backend.
            isQuickEstimate: data?.isQuickEstimate,
        } , {responseType: 'blob'});
        return res.data;
    } catch (error) {
        console.error("genereate pdf error:", error);
        throw error;
    }
}